// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1Q61Q","description":"PatientConsentPreview_description__3YBB-"};